import { PlanTier } from '@zapier/design-system-revenue/esm/types';

export const isTierFree = (tier: PlanTier): boolean => tier.pricePerTask === 0;
